import React, { useState } from 'react';
import taskService from '../../services/taskService';
import '../../assets/styles/Workflow.css';

interface RejectProjectModalProps {
  projectId: number;
  projectSummary: string;
  onClose: () => void;
  onRejected: (reason: string) => void;
}

// Rejected is a terminal stage reached from the same manual stage dropdown
// as the other 4 - but unlike those, it requires a reason, so it's routed
// through this small confirmation modal instead of applying immediately.
const RejectProjectModal: React.FC<RejectProjectModalProps> = ({ projectId, projectSummary, onClose, onRejected }) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleReject = async () => {
    if (!reason.trim()) {
      setError('A reason is required to reject a project');
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      await taskService.setProjectStage(projectId, 'rejected', reason.trim());
      onRejected(reason.trim());
      onClose();
    } catch (err: any) {
      setError((err?.response?.data?.message || err?.response?.message) || 'Failed to reject project');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="wf-overlay">
      <div className="wf-modal">
        <div className="wf-modal-head">
          <h2 style={{ fontSize: 17 }}>Reject project - {projectSummary}</h2>
          <button className="wf-iconbtn" onClick={onClose}>✕</button>
        </div>
        <div className="wf-modal-body">
          <div className="wf-stack wf-form">
            <div className="wf-lockrow" style={{ borderColor: '#fecaca', background: '#fef2f2', color: '#b91c1c' }}>
              This is a terminal status - once rejected, the project's status can no longer be changed.
            </div>
            <div>
              <label className="wf-field-label">Reason<span style={{ color: '#ef4444' }}> *</span></label>
              <textarea
                rows={4}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Why is this project being rejected?"
              />
            </div>
            {error && <div style={{ color: '#ef4444', fontSize: 13 }}>{error}</div>}
          </div>
        </div>
        <div className="wf-modal-foot">
          <button className="wf-btn" onClick={onClose}>Cancel</button>
          <button className="wf-btn wf-btn-primary" style={{ background: '#ef4444', borderColor: '#ef4444' }} disabled={submitting} onClick={handleReject}>
            {submitting ? 'Rejecting...' : 'Reject project'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectProjectModal;
